import classNames from "classnames";
import styles from "./AscGoToChallengesCard.module.scss";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import { ReactComponent as EmployeesIllustration } from "../../../assets/illustrations/employees.svg";
import AscButton from "../../AscButton/AscButton";
import { handleStopPropagation } from "@ascendnow/shared";
import AscLink from "../../AscLink/AscLink";

export interface AscGoToChallengesCardProps {
  className?: string;
  buttonText?: string;
  coverImageUrl?: string;
  title?: string;
  description?: string;
  coverImageClassName?: string;
  coverIllustration?: React.ReactNode;
  urlPath?: string;
  onButtonClick?: () => void;
  loading?: boolean;
}

export default function AscGoToChallengesCard({
  className,
  buttonText = "Go to challenges",
  coverImageUrl,
  coverImageClassName,
  title,
  description,
  urlPath,
  onButtonClick,
  coverIllustration,
  loading = false,
}: AscGoToChallengesCardProps) {
  return (
    <AscGenericCard
      title={title ? title : "Challenges"}
      data-testid="asc-go-to-challenges-card"
      className={classNames(
        styles.ground,
        {
          [styles.loading]: loading,
        },
        className
      )}
      coverImageUrl={coverImageUrl}
      customImage={
        coverIllustration || (coverImageUrl ? null : <EmployeesIllustration />)
      }
      titleClassName={styles.title}
      bodyClassName={styles.body}
      contentClassName={styles.content}
      imageClassName={coverImageClassName}
      loading={loading}
    >
      {description
        ? description
        : "A chance for you to try out these skills in your life. Let’s level up!"}
      {urlPath ? (
        <AscLink
          href={urlPath}
          className={styles.urlBtn}
          innerWrapperTag="button"
        >
          {buttonText}
        </AscLink>
      ) : (
        <AscButton
          variant="white"
          fullWidth
          onClick={handleStopPropagation(onButtonClick)}
        >
          {buttonText}
        </AscButton>
      )}
    </AscGenericCard>
  );
}
